<template>
  <WdsPopover
    trigger-element-id="bill-status-popover"
    placement="top"
    :fallback-placements="['top-start', 'bottom', 'bottom-end', 'left']"
    auto-update
    z-index="20"
    class="tw-p-6"
    global
  >
    <template #trigger="{ togglePopover }">
      <span class="tw-cursor-pointer" @click="togglePopover">
        <slot />
      </span>
    </template>
    <div class="tw-flex tw-flex-col tw-gap-lg" data-test="payment-request-timeline">
      <WdsProgress
        class="expanded"
        secondary
        :steps="progressSteps"
        :current="[]"
        :most-completed-step="mostCompletedProgressStep"
        :failed-steps="failedProgressSteps"
        sm
      >
        <template #parent="props">
          <div class="tw-min-w-full tw-max-w-[500px] tw-ml-4">
            <div class="tw-flex tw-flex-col tw-gap-1">
              <div class="tw-flex tw-flex-row tw-justify-between">
                <div>
                  <WdsText
                    large
                    primary
                    :text="props.mStep.name"
                    :tertiary="!props.mStep.completed"
                    :data-test="'payment-request-step-' + props.mIndex + '-name'"
                  />
                </div>
                <div class="tw-mr-8">
                  <span
                    v-if="props.mStep.overdue"
                    class="tw-text-orange-600"
                    data-test="payment-request-overdue-label"
                  >
                    Overdue
                  </span>
                  <template v-else>
                    <WdsText
                      v-if="!!props.mStep.date"
                      secondary
                      :text="props.mStep.date"
                      :tertiary="!props.mStep.completed"
                    />
                  </template>
                </div>
              </div>
              <div class="tw-w-3/4">
                <WdsText
                  default
                  secondary
                  :text="props.mStep.description"
                  :tertiary="!props.mStep.completed"
                />
              </div>
            </div>
          </div>
        </template>
      </WdsProgress>
      <div v-if="props.displayHelpMessage" class="tw-flex tw-justify-between">
        <WdsText secondary>{{ $t('Do you need help?') }}</WdsText>
        <a href="#" class="intercomchat">{{ $t('Contact us') }}</a>
      </div>
    </div>
  </WdsPopover>
</template>

<script lang="ts" setup>
import { WdsPopover, WdsProgress, WdsText } from '@worksome/wds-components'
import { computed } from 'vue'
import { useTranslation } from '@/composables/translation'

const { $t } = useTranslation()

interface Props {
  timeline: Array<any>
  displayHelpMessage?: boolean
  paymentRejectedReason?: string
}

const props = defineProps<Props>()

const progressSteps = computed(() => props.timeline)

const failedProgressSteps = computed(() => [
  ...props.timeline
    .map((step, index) => (step.failed ? index : -1))
    .filter((stepIndex) => stepIndex !== -1),
])

const mostCompletedProgressStep = computed(() => [
  props.timeline.findLastIndex((step) => step.completed),
])
</script>

<style lang="scss" scoped>
:deep(.wds-main-step) {
  align-items: start !important;
}

:deep(.wds-progress) {
  .wds-step:last-child .wds-main-step:before {
    top: calc(-100% + 10px);
  }
}

:deep(.completed-not-active) {
  cursor: auto !important;
}

:deep(.wds-chevron-container) {
  display: none !important;
}
</style>
